// extracted by mini-css-extract-plugin
export default {"skipMain":"App_skipMain__Hx1sV"};